import clsx from 'clsx'
import {FC} from 'react'
import {Row} from 'react-table'
import { getCellContent } from '../../../../../../utils/utils'
import { EventFailedType } from './_columns_3'

type Props = {
  row: Row<EventFailedType>
}

const CustomRow: FC<Props> = ({row}) => (
  <tr {...row.getRowProps()}>
    {row.cells.map((cell) => {
      const cellContent = getCellContent(cell)
      return (
        <td
          {...cell.getCellProps()}
          className={clsx({'text-end min-w-100px': cell.column.id === 'actions'})}
        >
          {cellContent}
        </td>
      )
    })}
  </tr>
)

export {CustomRow}
